import React, { useState, useEffect } from 'react';
import './Carrinho.css';
import { formatarPreco, converterParaNumero } from '../utils/formatters';
import { getImagemProduto } from '../utils/imageUtils';
import useNotification from '../hooks/useNotification';
import { useTracking } from '../hooks/useTracking';
import { buildApiUrl } from '../utils/api';
import Notification from './Notification';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Alert, Button } from 'antd';

const Carrinho = ({ onClose, onCarrinhoUpdate }) => {
  const [itens, setItens] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [processandoPedido, setProcessandoPedido] = useState(false);
  const [observacoes, setObservacoes] = useState('');
  const { trackEvent } = useTracking();
  const [carregandoCarrinho, setCarregandoCarrinho] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  
  // Estados para endereços
  const [enderecoEntregaIgualFaturamento, setEnderecoEntregaIgualFaturamento] = useState(true);
  const [dadosEntrega, setDadosEntrega] = useState({
    estado: '',
    cidade: '',
    cep: '',
    bairro: '',
    rua: '',
    numero: '',
    complemento: '',
    ponto_referencia: '',
    quem_recebera: ''
  });
  const [dadosFaturamento, setDadosFaturamento] = useState({
    estado: '',
    cidade: '',
    cep: '',
    bairro: '',
    rua: '',
    numero: '',
    complemento: '',
    ponto_referencia: ''
  });
  const [errosEndereco, setErrosEndereco] = useState({});
  const [dadosPessoais, setDadosPessoais] = useState({
    nome_completo: '',
    cpf: '',
    nome_empresa: '',
    cnpj: '',
    telefone: ''
  });
  const [errosDadosPessoais, setErrosDadosPessoais] = useState({});
  
  // Estados para logo extra
  const [desejaLogoExtra, setDesejaLogoExtra] = useState(false);
  const [imagensLogoExtra, setImagensLogoExtra] = useState([]);
  const [produtosLogoExtra, setProdutosLogoExtra] = useState('');
  const [entendeAlteracaoValor, setEntendeAlteracaoValor] = useState(false);
  const [errosLogoExtra, setErrosLogoExtra] = useState({});
  
  // Estado para notificações
  const [notificacao, setNotificacao] = useState({ show: false, message: '', type: 'error' });
  
  // Hook para notificações mobile
  const { notification: mobileNotification, showSuccess: showMobileSuccess, showError: showMobileError, showWarning: showMobileWarning, hideNotification: hideMobileNotification } = useNotification();

  // Estado para detectar se é mobile
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  
  // Estado para controlar se a loja está ativa
  const [lojaAtiva, setLojaAtiva] = useState(false); // false = loja desativada temporariamente

  // Função para mostrar notificação
  const mostrarNotificacao = (message, type = 'error') => {
    setNotificacao({ show: true, message, type });
    // Auto-hide após 5 segundos
    setTimeout(() => {
      setNotificacao(prev => ({ ...prev, show: false }));
    }, 5000);
  };

  // Função para fechar notificação
  const fecharNotificacao = () => {
    setNotificacao(prev => ({ ...prev, show: false }));
  };

  // Função para detectar se é mobile
  const checkIsMobile = () => {
    return window.innerWidth <= 768;
  };

  // Função para mostrar notificação (desktop ou mobile)
  const mostrarNotificacaoUnificada = (message, type = 'error') => {
    if (isMobileDevice) {
      if (type === 'success') {
        showMobileSuccess(message);
      } else if (type === 'error') {
        showMobileError(message);
      } else if (type === 'warning') {
        showMobileWarning(message);
      }
    } else {
      mostrarNotificacao(message, type);
    }
  };

  useEffect(() => {
    carregarCarrinho();
    verificarStatusLoja();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Detectar se é mobile e atualizar quando a tela for redimensionada
  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(checkIsMobile());
    };

    // Verificar no carregamento inicial
    handleResize();

    // Adicionar listener para redimensionamento
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Limpar URLs dos objetos quando o componente for desmontado
  useEffect(() => {
    return () => {
      imagensLogoExtra.forEach(imagem => {
        if (imagem.preview) {
          URL.revokeObjectURL(imagem.preview);
        }
      });
    };
  }, [imagensLogoExtra]);

  // Atualizar dados de faturamento quando enderecoEntregaIgualFaturamento mudar
  useEffect(() => {
    if (enderecoEntregaIgualFaturamento) {
      setDadosFaturamento({...dadosEntrega});
    }
  }, [enderecoEntregaIgualFaturamento, dadosEntrega]);




  const verificarStatusLoja = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(buildApiUrl('/api/loja/status'), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setLojaAtiva(data.ativa || false);
      } else {
        setLojaAtiva(false);
      }
    } catch (error) {
      console.error('Erro ao verificar status da loja:', error);
      setLojaAtiva(false);
    }
  };

  const carregarCarrinho = async () => {
    if (carregandoCarrinho) {
      return;
    }
    
    setCarregandoCarrinho(true);
    
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(buildApiUrl('/api/carrinho'), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        
        // Verificar se os itens têm preços válidos
        if (data.itens && data.itens.length > 0) {
          // Itens carregados com sucesso
        } else {
          console.log('Nenhum item no carrinho');
        }
        
        // Verificar se os dados são válidos antes de atualizar o estado
        if (data.total !== undefined && data.total !== null) {
          setItens(data.itens || []);
          setTotal(converterParaNumero(data.total));
        } else {
          setItens([]);
          setTotal(0);
        }
      } else {
        // Erro ao carregar carrinho
      }
    } catch (error) {
      // Erro ao carregar carrinho
    } finally {
      setLoading(false);
      setCarregandoCarrinho(false);
    }
  };

  const removerItem = async (itemId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(buildApiUrl(`/api/carrinho/${itemId}`), {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        // Adicionar um pequeno delay para evitar múltiplas chamadas
        setTimeout(() => {
          carregarCarrinho();
        }, 100);
        // Notificar sobre a atualização do carrinho
        if (onCarrinhoUpdate) {
          onCarrinhoUpdate();
        }
      } else {
        // Erro ao remover item
      }
    } catch (error) {
      // Erro ao remover item
    }
  };

  const finalizarPedido = async () => {
    if (itens.length === 0) {
      mostrarNotificacaoUnificada('Seu carrinho está vazio!', 'error');
      return;
    }

    // Validar dados pessoais
    const errosDadosPessoais = validarDadosPessoais(dadosPessoais);
    if (Object.keys(errosDadosPessoais).length > 0) {
      setErrosDadosPessoais(errosDadosPessoais);
      return;
    }

    // Validar endereço de entrega
    const errosEntrega = validarEndereco(dadosEntrega, 'entrega');
    let errosFaturamento = {};
    
    if (!enderecoEntregaIgualFaturamento) {
      errosFaturamento = validarEndereco(dadosFaturamento, 'faturamento');
    }

    const todosErros = { ...errosEntrega, ...errosFaturamento };
    
    if (Object.keys(todosErros).length > 0) {
      setErrosEndereco(todosErros);
      return;
    }

    // Validar logo extra se selecionado
    if (desejaLogoExtra) {
      const errosLogo = validarLogoExtra();
      if (Object.keys(errosLogo).length > 0) {
        setErrosLogoExtra(errosLogo);
        return;
      }
    }

    setProcessandoPedido(true);

    try {
      const token = localStorage.getItem('token');
      
      // Criar FormData para enviar dados e arquivos
      const formData = new FormData();
      
      // Adicionar dados básicos do pedido
      formData.append('dados_pessoais', JSON.stringify(dadosPessoais));
      formData.append('dados_entrega', JSON.stringify(dadosEntrega));
      formData.append('endereco_entrega_igual_faturamento', enderecoEntregaIgualFaturamento);
      formData.append('observacoes', observacoes);

      // Adicionar dados de faturamento (sempre enviar, mesmo se iguais)
      formData.append('dados_faturamento', JSON.stringify(dadosFaturamento));

      // Adicionar dados da logo extra se selecionado
      if (desejaLogoExtra) {
        formData.append('logo_extra', JSON.stringify({
          produtos: produtosLogoExtra,
          entende_alteracao_valor: entendeAlteracaoValor
        }));
        
        // Adicionar as imagens como arquivos
        imagensLogoExtra.forEach((imagem, index) => {
          formData.append(`logo_extra_imagens`, imagem.arquivo);
        });
      }

      const response = await fetch(buildApiUrl('/api/pedidos'), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        const textResponse = await response.text();
        throw new Error(`Erro no servidor: ${response.status} - ${textResponse}`);
      }

      if (response.ok) {
        mostrarNotificacaoUnificada(`Pedido #${data.pedido.id} finalizado com sucesso! Um email foi enviado com os detalhes.`, 'success');
        setItens([]);
        setTotal(0);
        setObservacoes('');
        // Resetar dados de endereço
        setDadosEntrega({
          estado: '',
          cidade: '',
          cep: '',
          bairro: '',
          rua: '',
          numero: '',
          complemento: '',
          ponto_referencia: '',
          quem_recebera: ''
        });
        setDadosFaturamento({
          estado: '',
          cidade: '',
          cep: '',
          bairro: '',
          rua: '',
          numero: '',
          complemento: '',
          ponto_referencia: ''
        });
        setDadosPessoais({
          nome_completo: '',
          cpf: '',
          nome_empresa: '',
          cnpj: '',
          telefone: ''
        });
        setEnderecoEntregaIgualFaturamento(true);
        setErrosEndereco({});
        setErrosDadosPessoais({});
        // Resetar dados da logo extra
        setDesejaLogoExtra(false);
        setImagensLogoExtra([]);
        setProdutosLogoExtra('');
        setEntendeAlteracaoValor(false);
        setErrosLogoExtra({});
        
        // Registrar evento de finalizar compra
        trackEvent('finalizar_compra', `Pedido finalizado - Total: R$ ${total.toFixed(2)}, Itens: ${itens.length}`);
        
        // Fechar o carrinho após um delay para permitir que a notificação seja vista
        setTimeout(() => {
          if (onClose) onClose();
        }, 3000); // 3 segundos de delay
      } else {
        mostrarNotificacaoUnificada(`Erro ao finalizar pedido: ${data.message || 'Erro desconhecido'}`, 'error');
      }
    } catch (error) {
      mostrarNotificacaoUnificada('Erro ao finalizar pedido. Tente novamente.', 'error');
    } finally {
      setProcessandoPedido(false);
    }
  };

  // Funções para gerenciar endereços
  const validarEndereco = (endereco, tipo) => {
    const erros = {};
    
    // Validações obrigatórias
    if (!endereco.estado || endereco.estado.length !== 2) {
      erros[`${tipo}_estado`] = 'Estado deve ter exatamente 2 caracteres';
    }
    
    if (!endereco.cidade || endereco.cidade.length < 2) {
      erros[`${tipo}_cidade`] = 'Cidade deve ter pelo menos 2 caracteres';
    }
    
    if (!endereco.cep || !/^\d{5}-\d{3}$/.test(endereco.cep)) {
      erros[`${tipo}_cep`] = 'CEP deve estar no formato 00000-000';
    }
    
    if (!endereco.bairro || endereco.bairro.length < 2) {
      erros[`${tipo}_bairro`] = 'Bairro deve ter pelo menos 2 caracteres';
    }
    
    if (!endereco.rua || endereco.rua.length < 5) {
      erros[`${tipo}_rua`] = 'Rua deve ter pelo menos 5 caracteres';
    }
    
    if (!endereco.numero || endereco.numero.length < 1) {
      erros[`${tipo}_numero`] = 'Número é obrigatório';
    }
    
    if (!endereco.quem_recebera || endereco.quem_recebera.length < 2) {
      erros[`${tipo}_quem_recebera`] = 'Quem receberá é obrigatório';
    }
    
    // Validações opcionais
    if (endereco.complemento && endereco.complemento.length > 100) {
      erros[`${tipo}_complemento`] = 'Complemento deve ter no máximo 100 caracteres';
    }
    
    if (endereco.ponto_referencia && endereco.ponto_referencia.length > 200) {
      erros[`${tipo}_ponto_referencia`] = 'Ponto de referência deve ter no máximo 200 caracteres';
    }
    
    return erros;
  };

  const validarDadosPessoais = (dados) => {
    const erros = {};
    
    if (!dados.nome_completo || dados.nome_completo.length < 3) {
      erros.nome_completo = 'Nome completo é obrigatório';
    }
    
    // CPF não é mais obrigatório - validar apenas se preenchido
    if (dados.cpf && dados.cpf.trim() !== '') {
      if (!/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(dados.cpf)) {
        erros.cpf = 'CPF deve estar no formato 000.000.000-00';
      }
    }
    
    // Nome da empresa não é mais obrigatório - validar apenas se preenchido
    if (dados.nome_empresa && dados.nome_empresa.trim() !== '' && dados.nome_empresa.length < 2) {
      erros.nome_empresa = 'Nome da empresa deve ter pelo menos 2 caracteres';
    }
    
    // CNPJ não é mais obrigatório - validar apenas se preenchido
    if (dados.cnpj && dados.cnpj.trim() !== '') {
      if (!/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(dados.cnpj)) {
        erros.cnpj = 'CNPJ deve estar no formato 00.000.000/0000-00';
      }
    }
    
    if (!dados.telefone || dados.telefone.length < 10) {
      erros.telefone = 'Telefone é obrigatório';
    }
    
    return erros;
  };

  const handleEnderecoChange = (tipo, campo, valor) => {
    if (tipo === 'entrega') {
      setDadosEntrega(prev => ({ ...prev, [campo]: valor }));
    } else {
      setDadosFaturamento(prev => ({ ...prev, [campo]: valor }));
    }
    
    // Limpar erro do campo quando o usuário começar a digitar
    setErrosEndereco(prev => {
      const novosErros = { ...prev };
      delete novosErros[`${tipo}_${campo}`];
      return novosErros;
    });
  };

  const handleEnderecoIgualChange = (checked) => {
    setEnderecoEntregaIgualFaturamento(checked);
    if (checked) {
      // Copiar dados de entrega para faturamento
      setDadosFaturamento({...dadosEntrega});
      // Limpar erros de faturamento
      setErrosEndereco(prev => {
        const novosErros = { ...prev };
        Object.keys(novosErros).forEach(key => {
          if (key.startsWith('faturamento_')) {
            delete novosErros[key];
          }
        });
        return novosErros;
      });
    }
  };

  const formatarCEP = (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length <= 5) {
      return cepLimpo;
    }
    return `${cepLimpo.slice(0, 5)}-${cepLimpo.slice(5, 8)}`;
  };

  // Função para buscar dados do CEP
  const buscarCEP = async (cep, tipo) => {
    const cepLimpo = cep.replace(/\D/g, '');
    
    if (cepLimpo.length !== 8) {
      return;
    }

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await response.json();

      if (data.erro) {
        console.log('CEP não encontrado');
        return;
      }

      // Preencher automaticamente os campos
      if (tipo === 'entrega') {
        setDadosEntrega(prev => ({
          ...prev,
          cep: cep,
          estado: data.uf || '',
          cidade: data.localidade || '',
          bairro: data.bairro || '',
          rua: data.logradouro || ''
        }));
      } else if (tipo === 'faturamento') {
        setDadosFaturamento(prev => ({
          ...prev,
          cep: cep,
          estado: data.uf || '',
          cidade: data.localidade || '',
          bairro: data.bairro || '',
          rua: data.logradouro || ''
        }));
      }

      // Limpar erros dos campos preenchidos automaticamente
      setErrosEndereco(prev => {
        const novosErros = { ...prev };
        delete novosErros[`${tipo}_estado`];
        delete novosErros[`${tipo}_cidade`];
        delete novosErros[`${tipo}_bairro`];
        delete novosErros[`${tipo}_rua`];
        return novosErros;
      });

    } catch (error) {
      // Erro ao buscar CEP
    }
  };

  const formatarCPF = (cpf) => {
    const cpfLimpo = cpf.replace(/\D/g, '');
    if (cpfLimpo.length <= 3) {
      return cpfLimpo;
    } else if (cpfLimpo.length <= 6) {
      return `${cpfLimpo.slice(0, 3)}.${cpfLimpo.slice(3)}`;
    } else if (cpfLimpo.length <= 9) {
      return `${cpfLimpo.slice(0, 3)}.${cpfLimpo.slice(3, 6)}.${cpfLimpo.slice(6)}`;
    } else {
      return `${cpfLimpo.slice(0, 3)}.${cpfLimpo.slice(3, 6)}.${cpfLimpo.slice(6, 9)}-${cpfLimpo.slice(9, 11)}`;
    }
  };

  const formatarTelefone = (telefone) => {
    const telefoneLimpo = telefone.replace(/\D/g, '');
    if (telefoneLimpo.length <= 2) {
      return telefoneLimpo;
    } else if (telefoneLimpo.length <= 7) {
      return `(${telefoneLimpo.slice(0, 2)}) ${telefoneLimpo.slice(2)}`;
    } else if (telefoneLimpo.length <= 11) {
      return `(${telefoneLimpo.slice(0, 2)}) ${telefoneLimpo.slice(2, 7)}-${telefoneLimpo.slice(7)}`;
    } else {
      return `(${telefoneLimpo.slice(0, 2)}) ${telefoneLimpo.slice(2, 7)}-${telefoneLimpo.slice(7, 11)}`;
    }
  };

  const formatarCNPJ = (cnpj) => {
    const cnpjLimpo = cnpj.replace(/\D/g, '');
    if (cnpjLimpo.length <= 2) {
      return cnpjLimpo;
    } else if (cnpjLimpo.length <= 5) {
      return `${cnpjLimpo.slice(0, 2)}.${cnpjLimpo.slice(2)}`;
    } else if (cnpjLimpo.length <= 8) {
      return `${cnpjLimpo.slice(0, 2)}.${cnpjLimpo.slice(2, 5)}.${cnpjLimpo.slice(5)}`;
    } else if (cnpjLimpo.length <= 12) {
      return `${cnpjLimpo.slice(0, 2)}.${cnpjLimpo.slice(2, 5)}.${cnpjLimpo.slice(5, 8)}/${cnpjLimpo.slice(8)}`;
    } else {
      return `${cnpjLimpo.slice(0, 2)}.${cnpjLimpo.slice(2, 5)}.${cnpjLimpo.slice(5, 8)}/${cnpjLimpo.slice(8, 12)}-${cnpjLimpo.slice(12, 14)}`;
    }
  };

  // Funções para gerenciar logo extra
  const validarLogoExtra = () => {
    const erros = {};
    
    if (desejaLogoExtra) {
      if (imagensLogoExtra.length === 0) {
        erros.imagens = 'Pelo menos uma imagem é obrigatória';
      }
      
      if (!produtosLogoExtra || produtosLogoExtra.trim().length < 3) {
        erros.produtos = 'Especifique em quais produtos deseja a logo extra';
      }
      
      if (!entendeAlteracaoValor) {
        erros.entende_alteracao = 'Você deve confirmar que entende que o valor pode alterar';
      }
    }
    
    return erros;
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const maxSize = 10 * 1024 * 1024; // 10MB em bytes
    
    // Validar tamanho das imagens
    const validFiles = files.filter(file => {
      if (file.size > maxSize) {
        mostrarNotificacaoUnificada(`A imagem ${file.name} é muito grande. Tamanho máximo permitido: 10MB`, 'error');
        return false;
      }
      return true;
    });
    
    // Armazenar os arquivos diretamente (não converter para base64)
    validFiles.forEach(file => {
      setImagensLogoExtra(prev => [...prev, {
        nome: file.name,
        arquivo: file, // Armazenar o arquivo original
        tamanho: file.size,
        preview: URL.createObjectURL(file) // Para preview apenas
      }]);
    });
    
    // Limpar erro das imagens
    setErrosLogoExtra(prev => ({ ...prev, imagens: '' }));
  };

  const removerImagem = (index) => {
    setImagensLogoExtra(prev => {
      const novaLista = prev.filter((_, i) => i !== index);
      // Limpar a URL do objeto para liberar memória
      if (prev[index] && prev[index].preview) {
        URL.revokeObjectURL(prev[index].preview);
      }
      return novaLista;
    });
  };

  // Funções para navegação entre passos
  const nextStep = () => {
    // Verificar se a loja está ativa
    if (!lojaAtiva) {
      mostrarNotificacaoUnificada('A loja está temporariamente desativada. Em breve voltaremos!', 'warning');
      return;
    }

    if (currentStep === 1) {
      // Validar dados pessoais
      const errosDadosPessoais = validarDadosPessoais(dadosPessoais);
      if (Object.keys(errosDadosPessoais).length > 0) {
        setErrosDadosPessoais(errosDadosPessoais);
        return;
      }
      setCurrentStep(2);
    } else if (currentStep === 2) {
      // Validar endereço de entrega
      const errosEntrega = validarEndereco(dadosEntrega, 'entrega');
      if (Object.keys(errosEntrega).length > 0) {
        setErrosEndereco(errosEntrega);
        return;
      }
      setCurrentStep(3);
    } else if (currentStep === 3) {
      // Validar endereço de faturamento se necessário
      if (!enderecoEntregaIgualFaturamento) {
        const errosFaturamento = validarEndereco(dadosFaturamento, 'faturamento');
        if (Object.keys(errosFaturamento).length > 0) {
          setErrosEndereco(prev => ({ ...prev, ...errosFaturamento }));
          return;
        }
      }
      setCurrentStep(4);
    } else if (currentStep === 4) {
      // Validar logo extra se selecionado
      if (desejaLogoExtra) {
        const errosLogo = validarLogoExtra();
        if (Object.keys(errosLogo).length > 0) {
          setErrosLogoExtra(errosLogo);
          return;
        }
      }
      // Finalizar pedido
      finalizarPedido();
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const getStepTitle = () => {
    switch (currentStep) {
      case 1: return 'Meus Dados';
      case 2: return 'Endereço de Entrega';
      case 3: return 'Endereço de Faturamento';
      case 4: return 'Logo Extra e Observações';
      default: return 'Meus Dados';
    }
  };



  if (loading) {
    return (
      <div className="carrinho-page">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Carregando carrinho...</p>
        </div>
      </div>
    );
  }

  // Se a loja estiver desativada, mostrar mensagem
  if (!lojaAtiva) {
    return (
      <div className="carrinho-page">
        <div className="loja-desativada-container">
          <div className="loja-desativada-card">
            <div className="loja-desativada-icon">
              <ExclamationCircleOutlined style={{ fontSize: '80px', color: '#ff6b6b' }} />
            </div>
            <h1 className="loja-desativada-titulo">A loja está temporariamente desativada</h1>
            <p className="loja-desativada-mensagem">Em breve voltaremos!</p>
            <p className="loja-desativada-descricao">
              Aguarde o próximo período de compras para realizar seus pedidos. 
              Fique atento aos nossos comunicados!
            </p>
            <Button 
              type="primary"
              size="large"
              onClick={() => window.location.href = '/painel'}
              style={{ height: '48px', fontSize: '16px' }}
            >
              Voltar ao Painel
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="carrinho-page">
      {/* Notificação Desktop */}
      {notificacao.show && (
        <div className={`notification ${notificacao.type}`}>
          <div className="notification-content">
            <div className="notification-icon">
              {notificacao.type === 'success' ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22,4 12,14.01 9,11.01"/>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              )}
            </div>
            <div className="notification-message">
              {notificacao.message}
            </div>
            <button className="notification-close" onClick={fecharNotificacao}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Notificação Mobile */}
      <Notification
        show={mobileNotification.show}
        message={mobileNotification.message}
        type={mobileNotification.type}
        onClose={hideMobileNotification}
        duration={5000}
      />



      {/* Conteúdo Principal */}
      <div className="carrinho-content">
        {itens.length === 0 ? (
          <div className="carrinho-vazio">
            <div className="empty-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="9" cy="21" r="1"/>
                <circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
            </div>
            <h3>Seu carrinho está vazio</h3>
            <p>Adicione alguns produtos para continuar</p>
            <button className="btn-continuar" onClick={onClose}>
              Continuar Comprando
            </button>
          </div>
        ) : (
          <div className="carrinho-layout">
            {/* Coluna Esquerda - Formulários */}
            <div className="carrinho-left">
              {/* Progress Steps - Desktop */}
              <div className="progress-steps-left desktop-only">
                <span className="step-label completed">Carrinho</span>
                <span className="step-separator">&gt;</span>
                <span className={`step-label ${currentStep === 1 ? 'active' : currentStep > 1 ? 'completed' : ''}`}>Meus Dados</span>
                <span className="step-separator">&gt;</span>
                <span className={`step-label ${currentStep === 2 ? 'active' : currentStep > 2 ? 'completed' : ''}`}>Endereço</span>
                <span className="step-separator">&gt;</span>
                <span className={`step-label ${currentStep === 3 ? 'active' : currentStep > 3 ? 'completed' : ''}`}>Faturamento</span>
                <span className="step-separator">&gt;</span>
                <span className={`step-label ${currentStep === 4 ? 'active' : ''}`}>Logo Extra</span>
              </div>

              {/* Progress Steps - Mobile */}
              <div className="progress-steps-mobile mobile-only">
                <span className="step-label active">{getStepTitle()}</span>
              </div>

              {/* Título da Seção Atual */}
              <div className="section-header">
                <h2>{getStepTitle()}</h2>
              </div>

              {/* Passo 1: Meus Dados */}
              {currentStep === 1 && (
                <div className="form-section">
                  {/* Aviso informativo sobre documentos */}
                  <Alert
                    message={
                      <div>
                        <strong>Orientações de preenchimento:</strong>
                        <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                          <li><strong>Colaboradores internos:</strong> favor preencherem apenas o CPF</li>
                          <li><strong>Franqueados:</strong> favor preencherem o CNPJ e nome da empresa</li>
                        </ul>
                      </div>
                    }
                    type="info"
                    showIcon
                    style={{ marginBottom: '20px' }}
                  />
                  
                  {Object.keys(errosDadosPessoais).length > 0 && (
                    <Alert
                      message="Por favor, corrija os erros nos dados pessoais antes de continuar."
                      type="warning"
                      showIcon
                      closable
                      style={{ marginBottom: '20px' }}
                    />
                  )}
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="nome-completo">Nome Completo <span className="required">*</span></label>
                      <input
                        type="text"
                        id="nome-completo"
                        value={dadosPessoais.nome_completo}
                        onChange={(e) => {
                          setDadosPessoais(prev => ({ ...prev, nome_completo: e.target.value }));
                          setErrosDadosPessoais(prev => ({ ...prev, nome_completo: '' }));
                        }}
                        placeholder="Digite seu nome completo"
                        className={errosDadosPessoais.nome_completo ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="cpf">CPF</label>
                      <input
                        type="text"
                        id="cpf"
                        value={dadosPessoais.cpf}
                        onChange={(e) => {
                          setDadosPessoais(prev => ({ ...prev, cpf: formatarCPF(e.target.value) }));
                          setErrosDadosPessoais(prev => ({ ...prev, cpf: '' }));
                        }}
                        placeholder="000.000.000-00"
                        maxLength="14"
                        className={errosDadosPessoais.cpf ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="nome-empresa">Nome da Empresa</label>
                      <input
                        type="text"
                        id="nome-empresa"
                        value={dadosPessoais.nome_empresa}
                        onChange={(e) => {
                          setDadosPessoais(prev => ({ ...prev, nome_empresa: e.target.value }));
                          setErrosDadosPessoais(prev => ({ ...prev, nome_empresa: '' }));
                        }}
                        placeholder="Digite o nome da empresa (franqueados)"
                        className={errosDadosPessoais.nome_empresa ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="cnpj">CNPJ</label>
                      <input
                        type="text"
                        id="cnpj"
                        value={dadosPessoais.cnpj}
                        onChange={(e) => {
                          setDadosPessoais(prev => ({ ...prev, cnpj: formatarCNPJ(e.target.value) }));
                          setErrosDadosPessoais(prev => ({ ...prev, cnpj: '' }));
                        }}
                        placeholder="00.000.000/0000-00 (franqueados)"
                        maxLength="18"
                        className={errosDadosPessoais.cnpj ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="telefone">Telefone <span className="required">*</span></label>
                      <input
                        type="text"
                        id="telefone"
                        value={dadosPessoais.telefone}
                        onChange={(e) => {
                          setDadosPessoais(prev => ({ ...prev, telefone: formatarTelefone(e.target.value) }));
                          setErrosDadosPessoais(prev => ({ ...prev, telefone: '' }));
                        }}
                        placeholder="(00) 00000-0000"
                        maxLength="16"
                        className={errosDadosPessoais.telefone ? 'error' : ''}
                      />
                    </div>
                  </div>
                </div>
              )}


              {/* Passo 2: Endereço de Entrega */}
              {currentStep === 2 && (
                <div className="form-section">
                  {Object.keys(errosEndereco).filter(key => key.startsWith('entrega')).length > 0 && (
                    <Alert
                      message="Por favor, corrija os erros no endereço de entrega antes de continuar."
                      type="warning"
                      showIcon
                      closable
                      style={{ marginBottom: '20px' }}
                    />
                  )}
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="cep-entrega">CEP <span className="required">*</span></label>
                      <input
                        type="text"
                        id="cep-entrega"
                        value={dadosEntrega.cep}
                        onChange={(e) => {
                          const cepFormatado = formatarCEP(e.target.value);
                          handleEnderecoChange('entrega', 'cep', cepFormatado);
                          // Buscar dados automaticamente quando CEP estiver completo
                          if (cepFormatado.replace(/\D/g, '').length === 8) {
                            buscarCEP(cepFormatado, 'entrega');
                          }
                        }}
                        placeholder="00000-000"
                        maxLength="9"
                        className={errosEndereco.entrega_cep ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="estado-entrega">Estado <span className="required">*</span></label>
                      <input
                        type="text"
                        id="estado-entrega"
                        value={dadosEntrega.estado}
                        onChange={(e) => handleEnderecoChange('entrega', 'estado', e.target.value.toUpperCase())}
                        placeholder="Ex: SP"
                        maxLength="2"
                        className={errosEndereco.entrega_estado ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="cidade-entrega">Cidade <span className="required">*</span></label>
                      <input
                        type="text"
                        id="cidade-entrega"
                        value={dadosEntrega.cidade}
                        onChange={(e) => handleEnderecoChange('entrega', 'cidade', e.target.value)}
                        placeholder="Digite a cidade"
                        className={errosEndereco.entrega_cidade ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="bairro-entrega">Bairro <span className="required">*</span></label>
                      <input
                        type="text"
                        id="bairro-entrega"
                        value={dadosEntrega.bairro}
                        onChange={(e) => handleEnderecoChange('entrega', 'bairro', e.target.value)}
                        placeholder="Digite o bairro"
                        className={errosEndereco.entrega_bairro ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="rua-entrega">Rua <span className="required">*</span></label>
                      <input
                        type="text"
                        id="rua-entrega"
                        value={dadosEntrega.rua}
                        onChange={(e) => handleEnderecoChange('entrega', 'rua', e.target.value)}
                        placeholder="Digite o nome da rua"
                        className={errosEndereco.entrega_rua ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="numero-entrega">Número <span className="required">*</span></label>
                      <input
                        type="text"
                        id="numero-entrega"
                        value={dadosEntrega.numero}
                        onChange={(e) => handleEnderecoChange('entrega', 'numero', e.target.value)}
                        placeholder="123"
                        className={errosEndereco.entrega_numero ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="complemento-entrega">Complemento</label>
                      <input
                        type="text"
                        id="complemento-entrega"
                        value={dadosEntrega.complemento}
                        onChange={(e) => handleEnderecoChange('entrega', 'complemento', e.target.value)}
                        placeholder="Apartamento, casa, etc."
                        maxLength="100"
                        className={errosEndereco.entrega_complemento ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="ponto-referencia-entrega">Ponto de Referência</label>
                      <input
                        type="text"
                        id="ponto-referencia-entrega"
                        value={dadosEntrega.ponto_referencia}
                        onChange={(e) => handleEnderecoChange('entrega', 'ponto_referencia', e.target.value)}
                        placeholder="Próximo ao shopping, etc."
                        maxLength="200"
                        className={errosEndereco.entrega_ponto_referencia ? 'error' : ''}
                      />
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="quem-recebera-entrega">Quem receberá o pedido <span className="required">*</span></label>
                      <input
                        type="text"
                        id="quem-recebera-entrega"
                        value={dadosEntrega.quem_recebera}
                        onChange={(e) => handleEnderecoChange('entrega', 'quem_recebera', e.target.value)}
                        placeholder="Nome da pessoa que receberá"
                        className={errosEndereco.entrega_quem_recebera ? 'error' : ''}
                      />
                    </div>
                  </div>
                </div>
              )}


              {/* Passo 3: Endereço de Faturamento */}
              {currentStep === 3 && (
                <div className="form-section">
                  {!enderecoEntregaIgualFaturamento && Object.keys(errosEndereco).filter(key => key.startsWith('faturamento')).length > 0 && (
                    <Alert
                      message="Por favor, corrija os erros no endereço de faturamento antes de continuar."
                      type="warning"
                      showIcon
                      closable
                      style={{ marginBottom: '20px' }}
                    />
                  )}
                  <div className="checkbox-section">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={enderecoEntregaIgualFaturamento}
                        onChange={(e) => handleEnderecoIgualChange(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                      Endereço de faturamento é o mesmo do endereço de entrega?
                    </label>
                  </div>

                  {!enderecoEntregaIgualFaturamento && (
                    <div className="form-grid">
                      <div className="form-group">
                        <label htmlFor="cep-faturamento">CEP <span className="required">*</span></label>
                        <input
                          type="text"
                          id="cep-faturamento"
                          value={dadosFaturamento.cep}
                          onChange={(e) => {
                            const cepFormatado = formatarCEP(e.target.value);
                            handleEnderecoChange('faturamento', 'cep', cepFormatado);
                            // Buscar dados automaticamente quando CEP estiver completo
                            if (cepFormatado.replace(/\D/g, '').length === 8) {
                              buscarCEP(cepFormatado, 'faturamento');
                            }
                          }}
                          placeholder="00000-000"
                          maxLength="9"
                          className={errosEndereco.faturamento_cep ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="estado-faturamento">Estado <span className="required">*</span></label>
                        <input
                          type="text"
                          id="estado-faturamento"
                          value={dadosFaturamento.estado}
                          onChange={(e) => handleEnderecoChange('faturamento', 'estado', e.target.value.toUpperCase())}
                          placeholder="Ex: SP"
                          maxLength="2"
                          className={errosEndereco.faturamento_estado ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="cidade-faturamento">Cidade <span className="required">*</span></label>
                        <input
                          type="text"
                          id="cidade-faturamento"
                          value={dadosFaturamento.cidade}
                          onChange={(e) => handleEnderecoChange('faturamento', 'cidade', e.target.value)}
                          placeholder="Digite a cidade"
                          className={errosEndereco.faturamento_cidade ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="bairro-faturamento">Bairro <span className="required">*</span></label>
                        <input
                          type="text"
                          id="bairro-faturamento"
                          value={dadosFaturamento.bairro}
                          onChange={(e) => handleEnderecoChange('faturamento', 'bairro', e.target.value)}
                          placeholder="Digite o bairro"
                          className={errosEndereco.faturamento_bairro ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group full-width">
                        <label htmlFor="rua-faturamento">Rua <span className="required">*</span></label>
                        <input
                          type="text"
                          id="rua-faturamento"
                          value={dadosFaturamento.rua}
                          onChange={(e) => handleEnderecoChange('faturamento', 'rua', e.target.value)}
                          placeholder="Digite o nome da rua"
                          className={errosEndereco.faturamento_rua ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="numero-faturamento">Número <span className="required">*</span></label>
                        <input
                          type="text"
                          id="numero-faturamento"
                          value={dadosFaturamento.numero}
                          onChange={(e) => handleEnderecoChange('faturamento', 'numero', e.target.value)}
                          placeholder="123"
                          className={errosEndereco.faturamento_numero ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group full-width">
                        <label htmlFor="complemento-faturamento">Complemento</label>
                        <input
                          type="text"
                          id="complemento-faturamento"
                          value={dadosFaturamento.complemento}
                          onChange={(e) => handleEnderecoChange('faturamento', 'complemento', e.target.value)}
                          placeholder="Apartamento, casa, etc."
                          maxLength="100"
                          className={errosEndereco.faturamento_complemento ? 'error' : ''}
                        />
                      </div>

                      <div className="form-group full-width">
                        <label htmlFor="ponto-referencia-faturamento">Ponto de Referência</label>
                        <input
                          type="text"
                          id="ponto-referencia-faturamento"
                          value={dadosFaturamento.ponto_referencia}
                          onChange={(e) => handleEnderecoChange('faturamento', 'ponto_referencia', e.target.value)}
                          placeholder="Próximo ao shopping, etc."
                          maxLength="200"
                          className={errosEndereco.faturamento_ponto_referencia ? 'error' : ''}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}


              {/* Passo 4: Logo Extra e Observações */}
              {currentStep === 4 && (
                <div className="form-section">
                  {desejaLogoExtra && Object.keys(errosLogoExtra).length > 0 && (
                    <Alert
                      message="Por favor, corrija os erros na seção de logo extra antes de continuar."
                      type="warning"
                      showIcon
                      closable
                      style={{ marginBottom: '20px' }}
                    />
                  )}
                  <div className="logo-extra-section">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={desejaLogoExtra}
                        onChange={(e) => setDesejaLogoExtra(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                      Deseja adicionar uma logo extra para algum produto?
                    </label>
                  </div>

                  {/* Campos da Logo Extra (apenas se selecionado) */}
                  {desejaLogoExtra && (
                    <div className="logo-extra-campos">
                      <div className="logo-extra-upload">
                        <label htmlFor="logo-extra-imagens">Imagens da Logo Extra <span className="required">*</span></label>
                        <input
                          type="file"
                          id="logo-extra-imagens"
                          multiple
                          accept="image/*"
                          onChange={handleImageUpload}
                          className={errosLogoExtra.imagens ? 'error' : ''}
                        />
                        <p className="upload-info">Tamanho máximo por imagem: 10MB</p>
                        
                        {/* Preview das imagens */}
                        {imagensLogoExtra.length > 0 && (
                          <div className="imagens-preview">
                            <h5>Imagens selecionadas:</h5>
                            <div className="imagens-grid">
                              {imagensLogoExtra.map((imagem, index) => (
                                <div key={index} className="imagem-preview">
                                  <img src={imagem.preview} alt={imagem.nome} />
                                  <div className="imagem-info">
                                    <span className="imagem-nome">{imagem.nome}</span>
                                    <span className="imagem-tamanho">{(imagem.tamanho / 1024 / 1024).toFixed(2)} MB</span>
                                  </div>
                                  <button 
                                    type="button"
                                    className="btn-remover-imagem"
                                    onClick={() => removerImagem(index)}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="logo-extra-produtos">
                        <label htmlFor="produtos-logo-extra">Em quais produtos deseja a logo extra? <span className="required">*</span></label>
                        <textarea
                          id="produtos-logo-extra"
                          value={produtosLogoExtra}
                          onChange={(e) => {
                            setProdutosLogoExtra(e.target.value);
                            setErrosLogoExtra(prev => ({ ...prev, produtos: '' }));
                          }}
                          placeholder="Ex: Camisas, Bonés, etc."
                          rows="3"
                          maxLength="500"
                          className={errosLogoExtra.produtos ? 'error' : ''}
                        />
                      </div>

                      <div className="logo-extra-aviso">
                        <div className="aviso-box">
                          <p><strong><ExclamationCircleOutlined /> Importante:</strong> O valor final do pedido pode alterar com a adição da logo extra.</p>
                        </div>
                        
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            checked={entendeAlteracaoValor}
                            onChange={(e) => {
                              setEntendeAlteracaoValor(e.target.checked);
                              setErrosLogoExtra(prev => ({ ...prev, entende_alteracao: '' }));
                            }}
                            className={errosLogoExtra.entende_alteracao ? 'error' : ''}
                          />
                          <span className="checkmark"></span>
                          Entendo que o valor final do pedido pode alterar
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Seção de Observações */}
                  <div className="observacoes-section">
                    <label htmlFor="observacoes">Observações (opcional):</label>
                    <textarea
                      id="observacoes"
                      value={observacoes}
                      onChange={(e) => setObservacoes(e.target.value)}
                      placeholder="Digite observações adicionais sobre o pedido..."
                      rows="3"
                      maxLength="500"
                    />
                  </div>
                </div>
              )}

              {/* Botões de Navegação Mobile - Sempre no final da coluna esquerda */}
              <div className="mobile-navigation mobile-only">
                {currentStep > 1 && (
                  <button className="btn-prev" onClick={prevStep}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M19 12H5M12 19l-7-7 7-7"/>
                    </svg>
                    Voltar
                  </button>
                )}
                
                <button 
                  className="btn-next" 
                  onClick={nextStep} 
                  disabled={processandoPedido || !lojaAtiva}
                >
                  {!lojaAtiva ? 'Loja Desativada' : processandoPedido ? 'Processando...' : currentStep === 4 ? 'Finalizar Pedido' : 'Continuar'}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
                
                {/* Mensagem de loja desativada */}
                {!lojaAtiva && (
                  <div className="loja-desativada-mensagem">
                    A loja está temporariamente desativada. Em breve voltaremos!
                  </div>
                )}
              </div>

            </div>

            {/* Coluna Direita - Resumo */}
            <div className="carrinho-right">
              <div className="summary-card">
                <h3>Seu Carrinho</h3>
                <div className="itens-resumo">
                  {itens.map(item => (
                    <div key={item.id} className="item-resumo">
                      <div className="item-image">
                        <img 
                          src={getImagemProduto(item.product)} 
                          alt={item.product?.nome}
                          onError={(e) => {
                            e.target.src = '/images/placeholder.jpg';
                          }}
                        />
                      </div>
                      <div className="item-resumo-info">
                        <h4>{item.product?.nome}</h4>
                        {item.tamanho && <span className="tamanho-resumo">Tamanho: {item.tamanho}</span>}
                        <span className="quantidade-resumo">Qtd: {item.quantidade}</span>
                      </div>
                      <div className="item-resumo-actions">
                        <div className="preco-resumo">
                          {formatarPreco(parseFloat(item.product?.preco || 0) * item.quantidade)}
                        </div>
                        <button 
                          className="btn-remover-item"
                          onClick={() => removerItem(item.id)}
                          title="Remover item"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="cost-breakdown">
                  <div className="cost-item">
                    <span>Subtotal</span>
                    <span>{formatarPreco(total)}</span>
                  </div>
                </div>
                
                <div className="total-section">
                  <span className="total-label">Total</span>
                  <span className="total-value">{formatarPreco(total)}</span>
                </div>
              </div>

              {/* Botões de Navegação Desktop */}
              <div className="card-navigation desktop-only">
                {currentStep > 1 && (
                  <button className="btn-prev" onClick={prevStep}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M19 12H5M12 19l-7-7 7-7"/>
                    </svg>
                    Voltar
                  </button>
                )}
                
                <button 
                  className="btn-next" 
                  onClick={nextStep} 
                  disabled={processandoPedido || !lojaAtiva}
                >
                  {!lojaAtiva ? 'Loja Desativada' : processandoPedido ? 'Processando...' : currentStep === 4 ? 'Finalizar Pedido' : 'Continuar'}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
                
                {/* Mensagem de loja desativada */}
                {!lojaAtiva && (
                  <div className="loja-desativada-mensagem">
                    A loja está temporariamente desativada. Em breve voltaremos!
                  </div>
                )}
              </div>

            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default Carrinho; 


